'use client';

declare global {
  interface Window {
    dataLayer: Array<Record<string, unknown>>;
  }
}

/**
 * Push a form-related event to the GTM dataLayer.
 */
export function pushFormEvent(
  eventName: string,
  data: Record<string, unknown>
): void {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': eventName, ...data });
  }
}
